"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.czCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var czCountry = exports.czCountry = function czCountry(t) {
  return {
    id: 'CZ',
    name: t('Czech Republic'),
    flag: '🇨🇿',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{3}\s?[0-9]{2}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 100 00 or 602 00',
    phonePrefix: '420',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Prague',
    currency: 'EUR'
  };
};